import {Injectable} from "@angular/core";
import {EntitetId} from "./ressurser/ng2HttpKlientTilleggstyper";
import {EntitetType} from "./ressurser/generertNg2HttpKlient";

/** Definerer interne lenker referert i koden vår.
 * Interne lenker er samlet her for enkel oversikt over hvilke interne lenker vi operer med.
 *
 * Se også {@link BildeRessurser}, {@link RessursAdresser} og {@link EksterneLenker} */
@Injectable({providedIn: 'root'})
export class InterneLenker {

    constructor() {
    }

    entitetUrl(id: EntitetId, type: EntitetType) {
        return `/app/entitet/${type}/${id}`;
    }
}
